var render = function () {
  var _vm$searchVal$transac, _vm$searchVal$transac2, _vm$searchVal$transac3, _vm$searchVal$transac4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "dialog-class": "dialog-class",
      "centered": "",
      "size": "md"
    },
    on: {
      "shown": _vm.openForm,
      "hidden": function ($event) {
        return _vm.$emit('update:isShow', false);
      }
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function () {
        return [_c('h4', {
          staticClass: "mb-0 text-primary"
        }, [_vm._v(" " + _vm._s(_vm.$t("ar_client_account_transaction_history")) + " " + _vm._s(_vm.accountCode) + " ")]), _c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('ez-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "icon": "ezAr-icon-x",
            "size": "24",
            "color": "#114A9F"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('update:isShow', false);
            }
          }
        })], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.isShow,
      callback: function ($$v) {
        _vm.isShow = $$v;
      },
      expression: "isShow"
    }
  }, [_c('SectionTransformTable', [_c('div', {
    staticClass: "d-flex p-2 align-items-center"
  }, [_c('div', {
    staticClass: "outline-none d-flex",
    staticStyle: {
      "width": "70%",
      "margin-right": "40px"
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.refetchData.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "d-flex w-38 flex-column mr-5"
  }, [_c('label', {
    staticClass: "mb-1"
  }, [_vm._v(" Nội dung tìm kiếm ")]), _c('WidgetString', {
    attrs: {
      "placeholder": "Nội dung tìm kiếm"
    },
    model: {
      value: _vm.searchVal.text,
      callback: function ($$v) {
        _vm.$set(_vm.searchVal, "text", $$v);
      },
      expression: "searchVal.text"
    }
  })], 1), _c('div', {
    staticClass: "d-flex w-50 flex-column"
  }, [_c('label', {
    staticClass: "mb-1"
  }, [_vm._v(" Ngày giao dịch")]), _c('WidgetDateTime', {
    attrs: {
      "clearable": true,
      "isRange": true,
      "placeholder": "Ngày giao dịch"
    },
    model: {
      value: _vm.searchVal.transactionDate,
      callback: function ($$v) {
        _vm.$set(_vm.searchVal, "transactionDate", $$v);
      },
      expression: "searchVal.transactionDate"
    }
  })], 1)]), _c('div', {
    staticStyle: {
      "width": "30%",
      "padding-left": "20px",
      "margin-top": "30px"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.refetchData
    }
  }, [_c('ez-icon', {
    staticStyle: {
      "margin-right": "3px"
    },
    attrs: {
      "icon": "ezAr-icon-search"
    }
  }), _vm._v(_vm._s(_vm.$t("ar_common_search")))], 1)], 1)]), _c('div', {
    staticClass: "divider"
  }), _c('div', {
    staticClass: "px-1"
  }, [_c('EzTable', {
    ref: "tableRef",
    attrs: {
      "toolbar-config": {
        disableColumnChooser: true
      },
      "excelExportParams": {
        FromDate: (_vm$searchVal$transac = _vm.searchVal.transactionDate) === null || _vm$searchVal$transac === void 0 ? void 0 : _vm$searchVal$transac.startDate,
        ToDate: _vm.dayjs((_vm$searchVal$transac2 = _vm.searchVal.transactionDate) === null || _vm$searchVal$transac2 === void 0 ? void 0 : _vm$searchVal$transac2.endDate).add('1', 'day'),
        ArAccountId: _vm.id
      },
      "excel-export-api-code": "AR_HSAA03",
      "excelExport": _vm.arClient.api_ExcelAR_HSAA01,
      "dataSourceParams": {
        Text: _vm.searchVal.text,
        ArAccountId: _vm.id,
        FromDate: (_vm$searchVal$transac3 = _vm.searchVal.transactionDate) === null || _vm$searchVal$transac3 === void 0 ? void 0 : _vm$searchVal$transac3.startDate,
        ToDate: _vm.dayjs((_vm$searchVal$transac4 = _vm.searchVal.transactionDate) === null || _vm$searchVal$transac4 === void 0 ? void 0 : _vm$searchVal$transac4.endDate).add('1', 'day')
      },
      "columns": _vm.columns,
      "dataSource": _vm.arClient.api_AR_HSAA01
    },
    scopedSlots: _vm._u([{
      key: "beforeToolbarActions",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mr-3"
        }, [_c('span', {
          staticClass: " mr-1"
        }, [_vm._v("Số dư đầu kỳ (VND):")]), _c('span', {
          staticClass: "font-weight-bolder text-primary"
        }, [_vm._v(" " + _vm._s(_vm.openingBalance))])]), _c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('span', {
          staticClass: " mr-1"
        }, [_vm._v("Số dư cuối kỳ (VND):")]), _c('span', {
          staticClass: "font-weight-bolder text-primary"
        }, [_vm._v(_vm._s(_vm.lastSurplus))])])])];
      },
      proxy: true
    }])
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }